import React, { useContext, useEffect, useState } from 'react';
import BotonComposicion from '../components/svg/BotonComposicion';
import BotonTerritorios from '../components/svg/BotonTerritorios';
import BotonPartidos from '../components/svg/BotonPartidos';
import constantes from '../resources/constantes.json';
import BotonInfoGeneral from '../components/svg/BotonInfoGeneral';
import { useNomenclator } from './nomenclatorContext';
import { usePage, useMesa } from './pageContext';
import useIni from '../hooks/useIni';


const EleccionContext = React.createContext();
const SetElectionOptions = React.createContext();

const tabs = [
  {
    id: 'composicion',
    title: 'Seleccionar composicion',
    element: props => <BotonComposicion {...props} />,
  },
  {
    id: 'votosPartidos',
    title: 'Seleccionar votos a partidos',
    element: props => <BotonPartidos {...props} />,
  },
  {
    id: 'votosPartidosConsultas',
    title: 'Seleccionar votos a partidos',
    element: props => <BotonPartidos {...props} />,
  },
	{
		id: 'votosPartidosCarousel',
		title: 'Seleccionar votos a partidos',
		element: props => <BotonPartidos {...props} />,
	},
	{
		id: 'votosPartidosBar',
		title: 'Seleccionar votos a partidos',
		element: props => <BotonPartidos {...props} />,
	},
  {
    id: 'territorios',
    title: 'Seleccionar territorios',
    element: props => <BotonTerritorios {...props} />,
  },
  {
    id: 'infoGeneral',
    title: 'Seleccionar información general',
    element: props => <BotonInfoGeneral {...props} />,
  }
];

const computeTabs = (idElec, level, isCircus, showCurules) => {
  let activeTabs = tabs;
    const tabs2 = ['votosPartidosConsultas', 'votosPartidos', 'infoGeneral']
    const tabs3 = ['votosPartidosConsultas', 'votosPartidos', 'infoGeneral','territorios']
    const tabs4 = ['votosPartidosConsultas', 'votosPartidos', 'infoGeneral','territorios', 'composicion']
		const tabsPresidenciales = ['votosPartidosBar', 'infoGeneral','territorios']
		//Comentado por ser de elecciones legislativas
    // if(isCircus === 1){
    //   if(level === 1){
    //     activeTabs = activeTabs.filter(t => [6,8,9].includes(idElec) ? tabs3.includes(t.id) : tabs4.includes(t.id));
    //   }else if(level === 2){
    //     activeTabs = activeTabs.filter(t => tabs3.includes(t.id));
    //   }
    // } else if (isCircus === 2){
    //   activeTabs = activeTabs.filter(t => idElec === 7 ? tabs3.includes(t.id) : tabs4.includes(t.id));
    //   if(	 && idElec === 7){
    //     activeTabs = activeTabs.filter(t => t.id !== 'votosPartidos')
    //   }
    // } else if ( isCircus === 0){
    //   activeTabs = activeTabs.filter(t => level > 2 ? tabs2.includes(t.id) : tabs3.includes(t.id));
    // }
    // activeTabs = activeTabs.filter(t => [6, 8, 9].includes(idElec) ? t.id !== 'votosPartidos' : t.id !== 'votosPartidosConsultas')
    // if(!showCurules) activeTabs = activeTabs.filter(t => t.id !== 'composicion')
		activeTabs = activeTabs.filter(tab => tabsPresidenciales.includes(tab.id))
		if(level > 2){
			activeTabs = activeTabs.filter(tab => tab.id !== 'territorios')
		}
    return activeTabs	
}

const tableOptions = (elec, level, isCircus, showCurules, selectedTab) => {
  const curules = isCircus > 0 && showCurules;
  const votos = selectedTab.id !== 'composicion';
  const mostrarCandidatos = !(isCircus===2 && selectedTab.id !=='composicion')
  return {mostrarVotos: votos, mostrarCargos: curules, mostrarCandidatos:mostrarCandidatos}
}

const getOptions = (data, nomenclator, camaraID, tabID, showCurules, mesa) => {
  const levelNomencaltor = nomenclator.ambitos[data.elec].find(amb => amb.c === data.amb);
  const level =  mesa ? constantes.level.mesa : levelNomencaltor.l;
  const selectedCamara = camaraID && data.camaras.find(c => c.cam === camaraID) || data.camaras[0];
  const isCircus = selectedCamara?.cir ?? data.camaras[0].cir;
  const activeTabs = computeTabs(Number(data.elec), Number(level), Number(isCircus), showCurules);
  const selectedTab = tabID && activeTabs.find(tab => tab.id === tabID) || activeTabs[0];

  const options = {
    idEleccion: data.elec,
    camaras: data.camaras,
    selectedCamara: selectedCamara ?? data.camaras[0],
    tabs: activeTabs,
    selectedTab: selectedTab ?? activeTabs[0],
    tableOptions: tableOptions(Number(data.elec), Number(level), Number(isCircus), showCurules, selectedTab)
  }

  return options;
}

export function EleccionProvider({ children }) {
  const [elecOptions, setElecOptions] = useState(null);
  const mesa = useMesa();
  const ini = useIni();
  const nomenclator = useNomenclator();
  const pageState = usePage();
  const { data, urlInfo, requestedUrlInfo } = pageState;
  useEffect(() => {
    const showCurulesIniShc = ini.showCurules && data?.shc === '1';
    if (!pageState.isLoading && pageState.data && !elecOptions || elecOptions && elecOptions.idEleccion !== requestedUrlInfo.eleccion) {
      setElecOptions(getOptions(data, nomenclator, null, null, showCurulesIniShc, mesa));
    } else if(!pageState.isLoading && elecOptions && data.elec === elecOptions.idEleccion){
      setElecOptions(getOptions(data, nomenclator, elecOptions.selectedCamara.cam, elecOptions.selectedTab.id, showCurulesIniShc, mesa))
    }
  }, [pageState.data, elecOptions?.selectedCamara, elecOptions?.selectedTab]);
  
  return (
    <EleccionContext.Provider value={elecOptions}>
      <SetElectionOptions.Provider value={setElecOptions}>
          {children}
      </SetElectionOptions.Provider>
    </EleccionContext.Provider>
  );
}

export function useEleccion() {
  const context = useContext(EleccionContext);
  return context;
}

export function useSetEleccion() {
  const context = useContext(SetElectionOptions);
  return context;
}
